import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { scrollToTop } from '../app.utils';

import {
  StyledArrowOverlayBox,
  StyledBox,
  StyledFooterOverlayBox,
  StyledFooterOverlayTypography,
  StyledIconButton,
  StyledImage,
  StyledTextOverlayBox,
  StyledTextOverlayTypography,
} from './contact.styles';

export const Contact = () => {
  return (
    <StyledBox id="contact">
      <StyledImage
        src="/website_contact.jpg"
        alt="landscape photo of person, holding mylar balloons and a small red chair, in front of a red barn with a painted smiley face"
        loading="lazy"
      />
      <StyledTextOverlayBox>
        <StyledTextOverlayTypography>
          Booking | Press | General | <a href="mailto:carlhauck@gmail.com">carlhauck@gmail.com</a>
        </StyledTextOverlayTypography>
        <StyledTextOverlayTypography>
          Licensing | <a href="mailto:info@ghost-town.com">info@ghost-town.com</a>
        </StyledTextOverlayTypography>
      </StyledTextOverlayBox>
      <StyledFooterOverlayBox>
        <StyledFooterOverlayTypography>
          ©2025 Carl Hauck
        </StyledFooterOverlayTypography>
        <StyledFooterOverlayTypography>
          Photography by <a href="https://www.instagram.com/madamepancakes" target="_blank" rel="noopener noreferrer">Abi Humber</a> | Death Farm album art by <a href="https://www.instagram.com/pedroetcetera" target="_blank" rel="noopener noreferrer">Pedro Gomes</a>
        </StyledFooterOverlayTypography>
      </StyledFooterOverlayBox>
      <StyledArrowOverlayBox>
        <StyledIconButton>
          <FontAwesomeIcon icon={faChevronUp} onClick={scrollToTop} />
        </StyledIconButton>
      </StyledArrowOverlayBox>
    </StyledBox>
  );
};